import ListStore from '@/store/core/ListStore';
import { action, computed, override } from 'mobx';
import services from '@/api/services';
import { Partner } from '@/store/types';
import { numGroup } from '@/utils/filters';

export default class PartnerStore extends ListStore<{ items: Partner[] }> {
  @override filters = {
    id: '',
    year: '',
  };

  sortColumns: (keyof Partner)[] = ['sumIncome', 'sumTax', 'percentIncome'];

  @computed get processedData() {
    if (!this.data?.items || !this.data?.items?.length) return;
    const items = this.data.items.map((item: Partner) => ({
      ...item,
      sumTax: numGroup(item.sumTax),
      sumIncome: numGroup(item.sumIncome),
    }));

    return { items };
  }

  @action.bound async fetch() {
    this.isFetching = true;
    try {
      const {
        data: { partners },
      } = await services.selfEmployee.getPartners(this.notFalsyParams);
      this.data = { items: partners };
    } catch (e) {
      console.error(e);
    } finally {
      this.isFetching = false;
    }
  }
}
